export const API_URL = import.meta.env.VITE_API_URL;
export const APP_ENVIRONMENT = import.meta.env.VITE_APP_ENVIRONMENT;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export const APP_VARIANT = import.meta.env.VITE_APP_VARIANT || "default";
export const APP_VERSION: string = __APP_VERSION__;

const variantConfig = __APP_VARIANT_CONFIG__;

export const APP_NAME = variantConfig.appName;
export const DEVICE_NAME = variantConfig.deviceName;
export const APP_CREATOR = variantConfig.appCreator;
export const APP_CREATOR_WEBSITE = variantConfig.appCreatorWebsite;
export const COPYRIGHT_TEXT = variantConfig.copyrightText;
export const APP_BUNDLE_ID = variantConfig.bundleId;
